import { InputHTMLAttributes, RefObject, forwardRef, useState } from 'react';
import cn from '../../utils/classnames';
import FontAwesomeIcon from '../../ui/font-awesome-icon/font-awesome-icon';
import './input.scss';

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
    defaultValue?: string;
    error?: boolean;
    errorMessage?: string;
    helpText?: string;
    label?: string;
    labelClassName?: string;
    ref?: RefObject<HTMLInputElement>;
    type?: string;
    bigIcon?: boolean;
};

const Input = forwardRef<HTMLInputElement, InputProps>(
    (
        {
            helpText = '',
            name,
            id = '',
            bigIcon,
            label = '',
            defaultValue,
            placeholder = '',
            errorMessage = '',
            error = false,
            className = '',
            labelClassName = '',
            type = 'text',
            ...rest
        },
        ref
    ) => {
        const [showPassword, setShowPassword] = useState(false);

        return (
            <div className='input-container position-relative'>
                {label && (
                    <label className={labelClassName} htmlFor={id}>
                        {label}
                    </label>
                )}
                <div className='position-relative'>
                    <input
                        className={cn(className, { 'error-field': error })}
                        defaultValue={defaultValue}
                        id={id}
                        name={name}
                        placeholder={placeholder}
                        ref={ref}
                        type={!showPassword ? type : ''}
                        {...rest}
                    />
                    {type === 'password' && (
                        <span className='cursor-pointer eye-icon' onClick={() => setShowPassword(!showPassword)}>
                            <span className={cn({ 'd-none': !showPassword })}>
                                {bigIcon ? (
                                    <FontAwesomeIcon height={22} name='eye' theme='black' />
                                ) : (
                                    <FontAwesomeIcon height={12} name='eye' theme='grey' />
                                )}
                            </span>
                            <span className={cn({ 'd-none': showPassword })}>
                                {bigIcon ? (
                                    <FontAwesomeIcon height={22} name='eye-slash' theme='black' />
                                ) : (
                                    <FontAwesomeIcon height={12} name='eye-slash' theme='grey' />
                                )}
                            </span>
                        </span>
                    )}
                </div>
                {(errorMessage || helpText) && (
                    <div className={cn('text', { error })}>{error ? errorMessage : helpText}</div>
                )}
            </div>
        );
    }
);

export default Input;
